/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportParam } from '../../models/report-param';

export interface ReportParamGetRecord$Params {
  reportParamId?: number;
}

export function reportParamGetRecord(http: HttpClient, rootUrl: string, params?: ReportParamGetRecord$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportParam>> {
  const rb = new RequestBuilder(rootUrl, reportParamGetRecord.PATH, 'get');
  if (params) {
    rb.query('reportParamId', params.reportParamId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportParam>;
    })
  );
}

reportParamGetRecord.PATH = '/api/ReportParam/reportparam/singlerecord';
